<template>
  <nav
    class="flex w-full items-center justify-evenly bg-secondary py-3 shadow-md"
    :style="{ height: `${BOTTOM_NAVBAR_HEIGHT}px` }"
  >
    <div class="flex min-w-[80px] cursor-not-allowed flex-col items-center text-sm text-gray-500">
      <icon-settings-pause class="mb-1 h-6 w-6" />
      <span>Pausar</span>
    </div>
    <div
      class="flex min-w-[80px] flex-col items-center text-sm transition-colors duration-200"
      :class="scanColor"
      @click="handleScan"
    >
      <icon-qrcode class="mb-1 h-6 w-6" />
      <span>Ler Produto</span>
    </div>
    <div
      class="flex min-w-[80px] flex-col items-center text-sm transition-colors duration-200"
      :class="[disableHistory ? 'cursor-not-allowed text-gray-500' : historyColor]"
      @click="!disableHistory && handleHistory()"
    >
      <div class="relative">
        <span
          v-if="!disableHistory"
          class="absolute -right-6 -top-1 flex h-3.5 items-center justify-center rounded bg-neon-green px-1 text-[8px] font-bold uppercase tracking-wider text-[#1a1c23] shadow-md"
        >
          Novo
        </span>
        <icon-history class="mb-1 h-6 w-6" />
      </div>
      <span>Histórico</span>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { BOTTOM_NAVBAR_HEIGHT } from '@/constraints'
import { useAppStore } from '@/stores/app.store'
import { IconHistory, IconQrcode, IconSettingsPause } from '@tabler/icons-vue'
import { computed } from 'vue'

const appStore = useAppStore()
const scanColor = computed(() =>
  appStore.appCurrentPage == 'read_product'
    ? 'text-neon-green cursor-default'
    : 'text-white hover:text-gray-300 cursor-pointer'
)
const historyColor = computed(() =>
  appStore.appCurrentPage == 'history'
    ? 'text-neon-green cursor-default'
    : 'text-white hover:text-gray-300 cursor-pointer'
)
export interface BottomNavBarProps {
  callbackPause?: () => Promise<unknown>
  callbackScan?: () => Promise<unknown>
  callbackHistory?: () => Promise<unknown>
  disableHistory?: boolean
}

const props = defineProps<BottomNavBarProps>()

async function handleScan() {
  if (props.callbackScan) {
    await props.callbackScan()
  }
}

async function handleHistory() {
  if (props.callbackHistory) {
    await props.callbackHistory()
  }
}
</script>
